@if (datePicker.currentMode === 'dual-month-day') {
  <div
    class="td-wb-datepicker">
    <div class="td-wb-datepicker-range--left">
      <div class="td-wb-day-picker-header--left">
        <div class="td-wb-table__cell--left">
          <button type="button"
                  tdWbDatePickerButton
                  [tdWbFocusOnDisabled]="yearButtonRef()"
                  class="td-wb-left td-wb-day-picker__arrow-button"
                  (click)="datePicker.move(-1)"
                  [disabled]="navPrevDisabled()"
                  [attr.aria-label]="'tdWb.dayPicker.PREVIOUS_MONTH' | tdWbTranslate">
            <td-wb-icon class="td-wb-day-picker__icon"
                        iconId="arrow-left"
                        size="9x14" />
          </button>
        </div>
        <div [attr.colspan]="3 + (datePicker.showWeeks() ? 1 : 0)">
          <strong [id]="datePicker.uniqueId + '-title[0]'"
                  class="td-wb-vh"
                  aria-live="assertive"
                  role="heading"
                  aria-level="1"
                  [innerText]="title()[0]">
          </strong>
          <span
            class="td-wb-date-picker-header"
            [innerText]="title()[0]"></span>
        </div>
      </div>
      <table [hidden]="datePicker.currentMode !== 'dual-month-day'"
             class="td-wb-day-picker__table"
             role="grid"
             [attr.aria-labelledby]="datePicker.uniqueId + '-title[0]'"
             [attr.aria-activedescendant]="datePicker.activeDateId() ? datePicker.activeDateId() + '--picker-1' : null">
        <thead>
        <tr>
          @if (datePicker.showWeeks()) {
            <th class="td-wb-table__cell--center"></th>
          }
          @for (label of labels(); track label.abbr) {
            <th class="td-wb-table__cell--center">
              <small [attr.aria-label]="label.full">
            <span class="td-wb-date-picker-subheader"
                  [innerText]="label.abbr"></span>
              </small>
            </th>
          }
        </tr>
        </thead>
        <tbody>
          @for (row of rowsOfFirstMonth(); track index; let index = $index) {
            <tr>
              @if (datePicker.showWeeks()) {
                <td class="td-wb-table__cell--center">
                  <em class="td-wb-italic"
                      [innerText]="weekNumbers()?.[index]"></em>
                </td>
              }
              @for (dt of row; track dt.uid) {
                <td class="td-wb-table__cell--center"
                    role="gridcell"
                    [id]="dt.uid + '--picker-1'"
                    [attr.aria-label]="getAriaLabel(dt.date)"
                    [attr.aria-disabled]="!!dt.disabled">
                  @if (dt.isVisible) {
                    <button type="button"
                            tdWbDatePickerButton
                            class="td-wb-date-picker-cell"
                            [class.td-wb-date-picker-button--active]="dt.selected"
                            (click)="datePicker.select(dt.date)"
                            [disabled]="dt.disabled">
              <span [class.text-muted]="dt.secondary"
                    [class.text-info]="dt.current"
                    [innerText]="dt.label">
              </span>
                    </button>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="td-wb-datepicker-range--right">
      @if (datePicker.currentMode === 'dual-month-day') {
        <div class="td-wb-day-picker-header--right">
          <div [attr.colspan]="3 + (datePicker.showWeeks() ? 1 : 0)">
            <strong [id]="datePicker.uniqueId + '-title[1]'"
                    class="td-wb-vh"
                    aria-live="assertive"
                    role="heading"
                    aria-level="1"
                    [innerText]="title()[1]">
            </strong>
            <span class="td-wb-date-picker-header"
                  [innerText]="title()[1]"></span>
          </div>
          <div class="td-wb-table__cell--right">
            <button type="button"
                    tdWbDatePickerButton
                    [tdWbFocusOnDisabled]="yearButtonRef()"
                    class="td-wb-right td-wb-day-picker__arrow-button"
                    (click)="datePicker.move(1)"
                    [disabled]="navNextDisabled()"
                    [attr.aria-label]="'tdWb.dayPicker.NEXT_MONTH' | tdWbTranslate">
              <td-wb-icon class="td-wb-day-picker__icon"
                          iconId="arrow-right"
                          size="9x14" />
            </button>
          </div>
        </div>
      }
      <table [hidden]="datePicker.currentMode !== 'dual-month-day'"
             class="td-wb-day-picker__table"
             role="grid"
             [attr.aria-labelledby]="datePicker.uniqueId + '-title[1]'"
             [attr.aria-activedescendant]="datePicker.activeDateId() ? datePicker.activeDateId() + '--picker-2' : null">
        <thead>
        <tr>
          @if (datePicker.showWeeks()) {
            <th class="td-wb-table__cell--center"></th>
          }
          @for (label of labels(); track label.abbr) {
            <th class="td-wb-table__cell--center">
              <small [attr.aria-label]="label.full">
            <span class="td-wb-date-picker-subheader"
                  [innerText]="label.abbr"></span>
              </small>
            </th>
          }
        </tr>
        </thead>
        <tbody>
          @for (row of rowsOfSecondMonth(); track index; let index = $index) {
            <tr>
              @if (datePicker.showWeeks()) {
                <td class="td-wb-table__cell--center">
                  <em class="td-wb-italic"
                      [innerText]="weekNumbers()?.[index]"></em>
                </td>
              }
              @for (dt of row; track dt.uid) {
                <td class="td-wb-table__cell--center"
                    role="gridcell"
                    [id]="dt.uid + '--picker-2'"
                    [attr.aria-label]="getAriaLabel(dt.date)"
                    [attr.aria-disabled]="!!dt.disabled">
                  @if (dt.isVisible) {
                    <button type="button"
                            tdWbDatePickerButton
                            class="td-wb-date-picker-cell"
                            [class.td-wb-date-picker-button--active]="dt.selected"
                            (click)="datePicker.select(dt.date)"
                            [disabled]="dt.disabled">
            <span [class.text-muted]="dt.secondary"
                  [class.text-info]="dt.current"
                  [innerText]="dt.label">
            </span>
                    </button>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
